import { Grid, IconButton, Stack } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import IGridComponent from '../../../components/grid/i-grid.component';
import './product-detail.component.scss';
import { formatTo0Decimal, formatTo2Decimal, isEmpty, isEmptyArray, isNotEmpty, isNotEmptyArray, isNull } from '../../common/util.services';
import { useContext, useEffect, useState } from 'react';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import { AppContext } from '../../../app-context';
import SelectOrdPrdComponent from './select-ord-prd.component';
import EditCellComponent from '../../costing/detail/edit-cell.component';
import QualityCostingComponent from '../quality/quality-costing.component';
import TextComponent from '../../enquiry/enq-product/edit-text.component';
import dayjs from 'dayjs';
import { getEnquiryProduct } from '../../enquiry/enquiry.services';
import ProductDetailComponent from '../../enquiry/enq-product/product-detail.component';
import { HelpOutline } from '@mui/icons-material';

const ProductDetailPage = (props: any) => {
  const [open, setOpen] = useState(false);
  const [openQlty, setOpenQlty] = useState(false);
  const [addRowIndex, setAddRowIndex] = useState(0);
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [orderProducts, setOrderProducts] = useState(rows);
  const [openCellValue, setOpenCellValue] = useState(false);
  const [openTextValue, setOpenTextValue] = useState(false);
  const [cellTitle, setCellTitle] = useState('');
  const [cellLabel, setCellLabel] = useState('');
  const [cellValueRow, setCellValueRow] = useState<any>();
  const [costingId, setCostingId] = useState(null);
  const [costingCode, setCostingCode] = useState(null);
  const [openPrdDetail, setOpenPrdDetail] = useState(false);
  const [prdDetail, setPrdDetail] = useState(null);
  
  const columns: GridColDef[] = [
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, width: 120, editable: false },
    { field: 'costingCode', headerName: 'Cost Code', filterable: false, editable: false, sortable: false, width: 125 },
    { field: 'type', headerName: 'Cost Type', filterable: false, editable: false, sortable: false, width: 100 },
    { field: 'description', headerName: 'Description', filterable: false, editable: false, sortable: false, width: 140,
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={0}>
                                <IconButton size="small" onClick={() => openPrdDetailPage(params.row.enqProductId)}
                                  sx={{ p: 0.6, ml: -1 }}> <HelpOutline fontSize="small" color='secondary'/>
                                </IconButton>{params.row.description}</Stack>)
    },
    { field: 'uom', headerName: 'UOM', filterable: false, editable: false, sortable: false, width: 75 },
    { 
      field: 'totalCost', headerName: 'Price/Pack', filterable: false, editable: false, sortable: false, width: 100,
      valueFormatter: (totalCost: any) => formatTo2Decimal(totalCost)
    },
    { field: 'pack', headerName: 'Pc/Pack', filterable: false, editable: false, sortable: false, width: 75,
      valueFormatter: (value: any) => 0 === value ? 'NA' : value
    },
    {
      field: 'quantity', headerName: 'Qty', filterable: false, sortable: false, width: 70, editable: false,
      valueFormatter: (value: any) => formatTo0Decimal(value * 1)
    },
    {
      field: 'boxCount', headerName: '# Box', filterable: false, sortable: false, width: 60, editable: false,
      renderCell: (params) => { return isEmpty(params.row.qtyPerCarton) ? 'NA' : params.row.quantity/params.row.qtyPerCarton}
    },
    {
      field: 'value', headerName: 'Price', filterable: false, sortable: false, width: 85, editable: false,
      valueFormatter: (value: any) => isEmpty(value) ? '' : value.toLocaleString(undefined, {maximumFractionDigits: 0})
    },
    {
      field: 'poValue', headerName: 'PO Value', filterable: false, sortable: false, width: 85, editable: false,
      valueFormatter: (value: any) => isEmpty(value) ? '' : value.toLocaleString(undefined, {maximumFractionDigits: 0})
    },
    {
      field: 'targetDate', headerName: 'Target Date', filterable: false, editable: true, sortable: false, width: 100, type: 'date',
      valueFormatter: (targetDate: any) => isNotEmpty(targetDate) ? dayjs(targetDate).format('DD-MMM-YY') : '',
      valueSetter: (value, row) => { row.targetDate = value; return value; }
    },
    { 
      field: 'qltyParams', headerName: 'Quality', filterable: false, sortable: false, width: 90, editable: false,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openQualityPage(params) }}>{params.row.qltyParams}</div>}
    },
    { 
      field: 'scheduleCode', headerName: 'Schedule', filterable: false, sortable: false, width: 110, editable: false,
      valueFormatter: (value: any) => isEmpty(value) ? 'NA' : value
    },
    {
      field: 'orderRemarks', headerName: 'Remarks', filterable: false, sortable: false, width: 100, editable: false, type: 'string',
      valueSetter: (value, row) => { row.orderRemarks = value; return value; }
    }
  ];

  useEffect(() => {
    if (isNotEmptyArray(props.productDetail)) {
      setOrderProducts(props.productDetail);
    }
  },[props.productDetail])

  const processRowUpdate = (updatedRow: any, originalRow: any) => {
    if (props.processRowUpdate) {
      originalRow.value = +originalRow.totalCost * (isNull(originalRow.quantity) ? 0 : originalRow.quantity);
      props.processRowUpdate(originalRow);
    }
  }

  const openQualityPage = (params: any) => {
    if(isEmpty(props.orderId)) {
      appContext.setDialogMessage('Save the order first to set quality parameters.');
    } else {
      setCellValueRow(params.row);
      setCostingId(params.row.costingId);
      setCostingCode(params.row.code);
      setOpenQlty(true);
    }
  }

  const closePrdDetail = () => {
    setOpenPrdDetail(false);
  }

  const openPrdDetailPage = (prdId: string) => {
    getEnquiryProduct(prdId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setPrdDetail(response.data);
        setOpenPrdDetail(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }

  const openProductPage = (params: any) => {
    setAddRowIndex(orderProducts.length);
    setOpen(true);
  }

  const handleCellDoubleClick = (value: any) => {
    if('quantity' === value.field) {
      setCellValueRow(value.row);
      setCellTitle('Specify Order Quantity');
      setCellLabel('Order Quantity');
      openCellValuePopup();
    } else if('orderRemarks' === value.field) {
      setCellValueRow(value.row);
      setCellTitle('Order Remarks');
      setCellLabel('Order Remarks');
      openTextValuePopup();
    } else if('poValue' === value.field) {
      setCellValueRow(value.row);
      setCellTitle('Specify PO Value');
      setCellLabel('PO Value');
      openCellValuePopup();
    }
  }

  const closeCellValuePopup = () => {
    if(isNotEmpty(cellValueRow.quantity)) {
      cellValueRow.quantity = Math.round(cellValueRow.quantity);
      cellValueRow.value = cellValueRow.quantity * cellValueRow.totalCost;
    } else {
      cellValueRow.value = '';
    }
    setOpenCellValue(false);
  }

  const closeTextValuePopup = () => {
    setOpenTextValue(false);
  }

  const openCellValuePopup = () => {
    setOpenCellValue(true);
  }

  const openTextValuePopup = () => {
    setOpenTextValue(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleCloseQlty = (value: any) => {
    if(isNotEmpty(value)) {
      cellValueRow.qltyParams = value + ' /' + cellValueRow.qltyParams.split('/')[1]
    }

    setOpenQlty(false);
  }

  const onRowSelection = (selectedRows: any) => {
    setOpen(false);
    const selectedRow = selectedRows[0];
    const rowExist = orderProducts.filter((row: any) => (row.enqProductId === selectedRow.enqProductId));
    const rows = [...orderProducts];
    rows.splice(addRowIndex, 0, selectedRow)
    
    if (isEmptyArray(rowExist)) {
      setOrderProducts(rows);
      if (props.onRowSelection) {
        props.onRowSelection(rows);
      }
    } else {
      appContext.setDialogMessage('The product is already present in the order.');
    }
  }

  const deleteRow = (row: any) => {
    if(row.pojo > 0) {
      appContext.setDialogMessage('The product has a PO/JS. Delete the PO/JS first.');
    } else {
      const updatedRows = orderProducts.filter((r: any) => !(r.enqProductId === row.enqProductId));
      setOrderProducts(updatedRows);
      if (props.onRowDelete) {
        props.onRowDelete(updatedRows);
      }
    }
  }

  return (
    <div>
      <Grid container spacing={1}>
        <IGridComponent title='Product Details' rows={orderProducts} columns={columns} getRowId={(row: any) => row.enqProductId}
          apiRef={props.apiRef} showAction={true} showEditAction={false} showAddBtn={true} addRow={openProductPage} hideFooter={false}
          showApproveAction={false} showAddAction={false} showDownAction={false} showUpAction={false} cellDoubleClick={handleCellDoubleClick}
          hideFooterPagination={true} processRowUpdate={processRowUpdate} showDeleteAction={true} handleDeleteAction={deleteRow}/>
      </Grid>
      <IDialogComponent onClose={handleClose} open={open} title='Select Product' 
        dialogBody={<SelectOrdPrdComponent enquiryCode={props.enquiryCode} onRowSelection={onRowSelection} />} />
      <IDialogComponent onClose={closeCellValuePopup} open={openCellValue} title={cellTitle}
        dialogBody={<EditCellComponent data={cellValueRow} close={closeCellValuePopup} label={cellLabel}/>} />
      <IDialogComponent onClose={closeTextValuePopup} open={openTextValue} title={cellTitle}
        dialogBody={<TextComponent data={cellValueRow} close={closeTextValuePopup} label={cellLabel}/>} />
      <IDialogComponent onClose={handleCloseQlty} open={openQlty} title={'Set Quality Parameters'}
        dialogBody={<QualityCostingComponent close={handleCloseQlty} costingCode={costingCode} orderId={props.orderId} costingId={costingId}/>} />
      <IDialogComponent onClose={closePrdDetail} open={openPrdDetail} title={'Product Details'}
        dialogBody={<ProductDetailComponent readOnly={true} data={prdDetail} close={closePrdDetail}/>} />
    </div>
  );
}

export default ProductDetailPage;
